import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { GoPlus } from "react-icons/go";
import { FcMinus } from "react-icons/fc";

//styles
import styles from "@/assets/styles/components/toggle-add-button.module.scss";

interface IToggleAddButton {
  toggled?: boolean;
  onToggle: (isToggled: boolean) => Promise<void>;
}

const ToggleAddButton = ({ toggled, onToggle }: IToggleAddButton) => {
  const [isToggled, setToggled] = useState(toggled);
  const [isFirstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    //to remove animation on first load (while searching in shortlistForm it is critical)

    const id = setTimeout(() => {
      setFirstLoad(false);
    }, 300);

    return () => {
      clearTimeout(id);
    };
  }, []);

  useEffect(() => {
    if (typeof toggled !== "undefined") {
      setToggled(toggled);
    }
  }, [toggled]);

  async function onClick() {
    await onToggle(!!isToggled).then(() => setToggled(!isToggled));
  }

  return (
    <div className={classNames(styles["locl-toggle-add-button_wrapper"], { "remove-animation": isFirstLoad })}>
      <div
        onClick={onClick}
        className={classNames(styles["locl-toggle-add-button"], { [styles.toggled]: isToggled })}
        data-testid={isToggled ? "locl-toggle-add-button-added" : "locl-toggle-add-button-add"}
      >
        {isToggled ? <FcMinus /> : <GoPlus />} <p>Add<span>ed</span></p>
      </div>
    </div>
  );
};

export default ToggleAddButton;
